module.exports = __webpack_public_path__ + "img/boa.92bd9b1d.svg";